/// <reference path="../index.d.ts" />
import * as React from 'react';
import { getCardClassName } from '../card-type';

/**
 * 判断是否折两行
 *
 * @param {string} desc
 * @returns
 */
function needSplitDesc(desc: string) {
  return desc.indexOf('\n') > -1;
}

interface CardProps extends PcCoupon.IActivity {
  handleDrawCoupon: (cid: string, pid: string) => void;
  productId: string;
  status: string;
  canClick: boolean;
  logo: string;
  id: string;
}

export class Card extends React.Component<CardProps, {}> {
  handleDrawCoupon = (cid, pid) => e => {
    e.nativeEvent.stopImmediatePropagation();
    this.props.handleDrawCoupon(cid, pid);
  };
  stopClick(e) {
    e.nativeEvent.stopImmediatePropagation();
  }
  render() {
    const needSplit = needSplitDesc(this.props.presentationDescription);
    return (
      <li
        className={getCardClassName(this.props.rangeType).cardBackground}
        onClick={this.stopClick}
      >
        <div className="card-info" onClick={this.stopClick}>
          <div className="card-info-title" onClick={this.stopClick}>
            {this.props.logo && this.props.rangeType === 'cross_shop' && (
              <img className="forward-promotion-logo" src={this.props.logo} />
            )}
            <span onClick={this.stopClick} title={this.props.presentationTitle}>
              {this.props.presentationTitle}
            </span>
            {this.props.logo && this.props.rangeType !== 'cross_shop' && (
              <img className="promotion-logo" src={this.props.logo} />
            )}
          </div>
          {!needSplit && (
            <div
              className="card-info-price"
              onClick={this.stopClick}
              title={this.props.presentationDescription}
            >
              {this.props.presentationDescription}
            </div>
          )}
          {needSplit && (
            <div
              className="card-info-price"
              onClick={this.stopClick}
              title={this.props.presentationDescription.split('\n')[0]}
            >
              {this.props.presentationDescription.split('\n')[0]}
            </div>
          )}
          {needSplit && (
            <div
              className="card-info-other-desc"
              onClick={this.stopClick}
              title={this.props.presentationDescription.split('\n')[1]}
            >
              {this.props.presentationDescription.split('\n')[1]}
            </div>
          )}
          <div
            className="card-info-time"
            onClick={this.stopClick}
            title={this.props.presentationTime}
          >
            {this.props.presentationTime}
          </div>
        </div>
        <div
          className={
            this.props.canClick
              ? 'card-action'
              : 'card-action card-action-disable'
          }
          onClick={this.handleDrawCoupon(this.props.id, this.props.productId)}
          title={this.props.status}
        >
          <div className="action-text">{this.props.status}</div>
        </div>
      </li>
    );
  }
}
